import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { InputLabel } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';

const CategoryDropdown = (props) => {
    const {
        value,
        onChange,
        readonly,
        categoriesMapValues,
    } = props
    return (
        <Grid2>
            <FormControl className='scoring-form-div' variant="standard"
                sx={{ minWidth: '200px' }}>
                <InputLabel id="demo-simple-select-helper-label">Category</InputLabel>
                <Select
                    name="judgeUid"
                    value={value}
                    onChange={(e) => onChange(e, e.target.value || "")}
                    disabled={readonly}
                >
                    <MenuItem value={''}>Category</MenuItem>
                    {Object.keys(categoriesMapValues).map(cUid => {
                        return (
                            <MenuItem
                                key={cUid}
                                value={cUid}
                            >
                                {categoriesMapValues[cUid]}
                            </MenuItem>
                        )
                    })}

                </Select>
            </FormControl>
        </Grid2>
    )
}

export default CategoryDropdown